<template>
  <div id="mainAdminApp" style="height: 100%; position: relative; overflow: hidden">
    <div id="main-admin-container">
      <VirtualKeyboard></VirtualKeyboard>
      <div class="main-content">
        <div class="left-content" style="flex: 1">
          <router-view
            @dispose3DViewer="dispose3DViewer()"
            @launch-viewer="launchViewer3D"
            @launch-viewer-2d="launchViewer2D"
            :levels="levels"
            @update_levels="onUpdateLevels"
            @toggle-level-in-3d="toggleLevelIn3D"
            :modelsLoading="modelsLoading"
            @update_category="updateCategoryHandler"
            @delete_category="onDeleteCategory"
            :projects="projects"
            :selectedgpssystem="selectedGPSSystem"
            @open_3d_viewer="open3dViewerIfNot"
            @update_projects="onUpdateProjects"
            :pointclouds="pointclouds"
            @update_pointclouds="updatePointClouds"
            @isPointClouds_Deleted="isPointCloudsDeleted"></router-view>

          <AddAutomaticTagsPopup></AddAutomaticTagsPopup>
          <PopulateAutomaticTagsPopup
            v-if="showPopulateAutomaticTagsPopup"></PopulateAutomaticTagsPopup>
          <SyncAMISPopup v-if="isAMIS"></SyncAMISPopup>
        </div>
        <v-sheet
          id="admin-viewer-title"
          style="flex: 1"
          height="calc(100%)"
          class="d-flex align-center justify-start flex-column"
          v-if="shownModel || shownLevel2D">
          <div class="model-info-section" v-if="shownModel && shownModel.urn">
            <div class="model-info pa-2" v-if="shownModel.urn">
              <div>
                <span class="property-title">Model Name: </span>
                <span class="property-value" :title="shownModel.name"
                  >{{ shownModel.name }} ({{ shownModel.version }})</span
                >
              </div>
              <div style="display: flex; column-gap: 20px">
                <div class="property-wrapper">
                  <span class="property-title">Uploaded By: </span>
                  <span class="property-value" v-if="shownModel.createdBy" :title="shownModel.createdBy.displayName">{{
                    shownModel.createdBy.displayName
                  }}</span>
                  <span class="property-value" v-else> - </span>
                </div>
                <div class="property-wrapper">
                  <span class="property-title">On: </span>
                  <span class="property-value" :title="createdOn">{{ createdOn }}</span>
                </div>
                <div class="property-wrapper">
                  <span class="property-title">Size: </span>
                  <span class="property-value" :title="modelSize">{{ modelSize }}</span>
                </div>
                <div class="property-wrapper">
                  <span class="property-title">Original File Ext: </span>
                  <span class="property-value" :title="originalModelExt">{{
                    originalModelExt
                  }}</span>
                </div>
              </div>
              <div class="property-wrapper progress-circle" v-if="viewerState.isLoading">
                <v-progress-circular
                  size="50"
                  color="primary"
                  v-model="viewerState.percent">
                  <span class="font-weight-bold">
                    {{ Math.ceil(viewerState.percent) }}%
                  </span>
                </v-progress-circular>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              v-if="viewer"
              icon
              @click="toggleModelBrowser()"
              class="mr-4"
              title="Model Browser">
              <v-icon>mdi-file-tree</v-icon>
            </v-btn>
            <v-btn @click="dispose3DViewer()" icon><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-sheet
            style="max-height: calc(100% - 75px)"
            class="admin-viewer pa-2"
            id="admin-forge-viewer"
            v-if="shownModel && shownModel.urn"></v-sheet>

          <div class="upload-section" v-if="shownLevel2D && shownLevel2D.planUrn">
            <div class="top-points-above-plan" v-if="shownLevel2D && shownModel">
              <div
                id="first-point-button"
                :class="['admin-btn', isPoint1Valid ? '' : 'admin-btn-secondary']"
                @click="clickOnP1()">
                Point(1)
                <span>Click on the first same position on both 2D/3D Forge viewers</span>
              </div>
              <div
                id="second-point-button"
                :class="['admin-btn', isPoint2Valid ? '' : 'admin-btn-secondary']"
                @click="clickOnP2()">
                Point(2)
                <span>Click on the second same position on both 2D/3D Forge viewers</span>
              </div>
            </div>

            <div class="info-section" v-if="shownLevel2D.planUrn">
              <div>Model Name: {{ shownLevel2D.name }}</div>
            </div>

            <v-sheet v-if="shownLevel2D && !shownModel && !mappingInfo" class="d-flex justify-center align-center mr-4">
              <v-btn small :color="minPoint && maxPoint ? 'primary' : minPoint ? 'warning' : 'white'" @click="minPointHandle()" class="mr-2">
                Min Point
              </v-btn>
              <v-btn small :color="minPoint && maxPoint ? 'primary' : maxPoint ? 'warning' : 'white'" @click="maxPointHandle()">
                Max Point
              </v-btn>
            </v-sheet>

            <v-btn small color="error" right @click="dispose2DViewer()" icon>
              <v-icon small>
                mdi mdi-close
              </v-icon>
            </v-btn>
            <!-- <div class="top-right-btn" @click="dispose2DViewer()" title="Close">X</div> -->
          </div>
          <v-sheet
            style="max-height: calc(100%)"
            class="admin-viewer"
            id="admin-forge-viewer2d"
            v-if="shownLevel2D && shownLevel2D.planUrn"></v-sheet>
        </v-sheet>
        <!-- <markups-popup></markups-popup> -->
      </div>
      <FillTagsImagesPopup></FillTagsImagesPopup>

      <AdminStampsUpload ref="admin-stamps-upload"></AdminStampsUpload>
      <SuccessfulPopup v-if="localSuccessMessage" :message="localSuccessMessage"></SuccessfulPopup>
      <UpdateCategoryPopup
        :assetid="assetId"
        ref="UpdateCategoryPopup"
        @add_new_category="addNewCategory"
        @update_category="onUpdateCategory"></UpdateCategoryPopup>
      <!-- <EditShareFilePopup
        v-if="forgeSettings"
        @on-save="editShareFileLocation"></EditShareFilePopup> -->

      <UploadModel :assetId="assetId" @disposeViewer="disposeViewer()"></UploadModel>
      <MessagePopup></MessagePopup>
      <point-form-dialog ref="pointFormDialog"></point-form-dialog>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  const Autodesk = window.Autodesk;
  import { dispose3DViewer, dispose2DViewer, getPointOnViewerHandler } from '@/scripts/js/forgeviewer';
  import { ForgeSettings, ForgeLevel, ForgeProject, GPSSettings, MappingViewersInfo } from '@/scripts/js/forgeModels';
  import { objectToQueryParams } from '@/scripts/js/forgeService';
  import { getAllLeafComponents, getMiddleBBoxForGroup, getForgeToken } from '@/utils/forgeUtils';
  import { GET_ALL_DOCUMENTS } from '@/utils/attachmentsAPI';
  import { getAMISToken } from '@/utils/amisAPIs';
  import levelsService from '@/features/Admin/services/levels.service';
  import HttpService from '@/utils/httpService';

  import VirtualKeyboard from '@/components/virtual-keyboard/virtual-keyboard.vue';
  import MessagePopup from '@/components/common/messagePopup.vue';
  import UploadModel from '@/components/admin/popups/uploadModels.vue';
  import AddAutomaticTagsPopup from '@/components/admin/popups/addAutomaticTagsPopup.vue';
  import PopulateAutomaticTagsPopup from '@/components/admin/popups/populateAutomaticTagsPopup.vue';
  import SyncAMISPopup from '@/components/admin/components/A-MIS/syncAMISPopup.vue';
  import EditShareFilePopup from '@/components/shareFile/popups/shareFileEditPopup.vue';
  import UpdateCategoryPopup from '@/components/admin/popups/updateCategory.vue';

  import SuccessfulPopup from '@/components/common/successfulPopup.vue';
  import AdminStampsUpload from '@/components/admin/components/stamps/adminStampsUpload.vue';
  import FillTagsImagesPopup from '@/components/admin/popups/fillTagsImagesPopup.vue';
  import PointFormDialog from '@/features/Admin/components/PointFormDialog.vue';
  import permissions from '@Share/config/permissions';
  import { getStreamingApi } from '@/utils/regionUtils';
  import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
  import { resolvePersistUnitScale } from '@/utils/coordinateAuthority';

  export default {
    name: 'AdminView',
    components: {
      VirtualKeyboard,
      MessagePopup,
      UploadModel,
      AddAutomaticTagsPopup,
      PopulateAutomaticTagsPopup,
      SyncAMISPopup,

      // EditShareFilePopup,
      UpdateCategoryPopup,
      SuccessfulPopup,
      AdminStampsUpload,
      FillTagsImagesPopup,
      PointFormDialog
    },
    data() {
      return {
        permissions,
        shownModel: null,
        shownLevel2D: null,
        pointclouds: [],
        selectedGPSSystem: this.$store.state.forgeService.gpsSystems[0],
        isPoint1Valid: false,
        isPoint2Valid: false,
        modelsLoading: false,

        panning: false,
        minPoint: null,
        minPoint3d: null,
        maxPoint: null,
        maxPoint3d: null,

        modelSize: '-',
        originalModelExt: '-',
      };
    },
    created() {
      this.$store.state.adminAppContainer = this;
    },
    methods: {
      init() {
        this.modelsLoading = true;
        this.$store.state.forgeService.getForgeModels(this.assetId, (data) => {
          let forgeSettings = null;
          if (data != null) {
            if (data.models) {
              // data.models.forEach((o) => (o.isMainVersion = o.name == data.selectedModel));
              // this.$store.state.uploadedModels = data.models;
            }

            this.pointclouds = data.pointCloudModels;
            this.$store.commit('setPointClouds', data.pointCloudModels);

            forgeSettings = Object.assign(new ForgeSettings(), data.settings);
            if (!forgeSettings.inspectionFiltersColors)
              forgeSettings.inspectionFiltersColors = new ForgeSettings().inspectionFiltersColors;
            let levels = ForgeLevel.parseLevelsFromDB(data.levels);
            this.$store.commit('setLevels', levels);
            // let projects = ForgeProject.parseProjectsFromDB(data.projects);
            // this.$store.commit('setProjects', projects);

            if (data.categories && data.categories.length > 0) {
              this.$store.state.categories = data.categories;
            }

            var selectedLevel = levels.find((o) => o.name == data.selectedLevel);
            if (selectedLevel) selectedLevel.isSelected = true;

            if (data.shareFileParentId)
              this.$store.state.shareFileParentId = data.shareFileParentId;
          } else {
            forgeSettings = new ForgeSettings();
          }

          this.$store.commit('AREAS/SET_SELECTED_AREA_ID', data.selectedAreaId);

          if (!forgeSettings) forgeSettings = new ForgeSettings();
          //gps settings
          if (!forgeSettings.gpsSettings) forgeSettings.gpsSettings = new GPSSettings();
          forgeSettings.gpsSettings = Object.assign(new GPSSettings(), forgeSettings.gpsSettings);

          this.$store.state.forgeSettings = forgeSettings;

          if (forgeSettings.ignoredDbIds) {
            let ignoredDbIds = forgeSettings.ignoredDbIds.split(',').map(Number);
            this.$store.commit('SET_IGNORED_TAGS_IDS', new Uint32Array(ignoredDbIds));
          }

          this.$store.dispatch('LOAD_AMIS_COLORS');
          this.modelsLoading = false;
        });

        this.$store.dispatch('FETCH_ALL_DOCUMENTS');
      },
      async open3dViewerIfNot() {
        let currentModel = await this.$store.dispatch('GET_MAIN_MODEL');
        if (!currentModel) {
          this.$dialog.notify.warning(
            'No model 3d found, please upload and select a 3d model first.',
            {
              position: 'top-right',
              timeout: 3000,
            },
          );
          return false;
        }
        if (this.viewer && currentModel.urn == this.$store.state.currentUrn) return true;
        this.launchViewer3D(currentModel);
        return true;
      },
      editShareFileLocation(id) {
        this.$store.state.forgeSettings.shareFileParentId = id;

        HttpService({
          url: 'api/forge/settings/updateAssetShareFileParent',
          data: { assetId: this.$store.state.assetId, shareFileParentId: id },
        }).catch((error) => {
          debugLog(error);
        });
      },
      toggleModelBrowser() {
        if (!this.viewer) return;

        const visible = this.viewer.modelstructure?.visible;

        this.viewer.modelstructure?.setVisible(!visible);
      },
      launchViewer3D(model) {

        this.dispose3DViewer();
        this.modelSize = '-';
        this.originalModelExt = '-';
        this.shownModel = model;
        this.launchViewer_Admin(model.urn, 'admin-forge-viewer', (viewer0) => {
          this.viewer = viewer0;

          this.$store.dispatch('SET_VIEWER_DISPLAY_DEFAULT_PREFERENCES');

          this.viewer.addEventListener(Autodesk.Viewing.PROGRESS_UPDATE_EVENT, (event) => {
            this.$store.state.viewerState.percent = event.percent;
            this.$store.state.viewerState.isLoading = event.percent != 100;
          });

          this.originalModelExt =
            this.viewer.model.getDocumentNode()?.name()?.split('.')?.pop() ?? '-';

          if (this.viewer && !model.displayUnit) {
            // Fill-when-missing only. The previous `!!model.displayUnit` check was
            // inverted: it overwrote a user-confirmed facility unit with the model's
            // self-declared unit string (wrong for mis-declared re-uploads) and never
            // filled a missing one.
            let displayUnit = this.viewer.model.getUnitString();

            if (displayUnit) {
              model.displayUnit = displayUnit;

              this.$store.dispatch({
                type: 'updateDisplayUnit',
                displayUnit: displayUnit,
              });
            }
          }

          // globalOffset: live model (defines viewer space). unitScale: facility
          // displayUnit is the authority; the model's declaration only fills the gap.
          const unitResolution = resolvePersistUnitScale(this.viewer.model);
          this.$store.commit('SET_GLOBAL_OFFSET', this.viewer.model.getGlobalOffset());
          this.$store.commit('SET_UNIT_SCALE', unitResolution.scale || this.viewer.model.getUnitScale());
          if (unitResolution.conflict) {
            debugWarn('[Admin] Unit mismatch: facility display unit ' +
              `'${unitResolution.displayUnit}' (scale ${unitResolution.scale}) vs ` +
              `model-declared ${unitResolution.modelScale}. Keeping the facility unit.`);
          }

          this.viewer.loadExtension('MainExtension');
          this.viewer.loadExtension('Mapping2d_3dExtension');

          this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, (_) => {
            this.modelSize = `${(
              this.viewer.model.getGeometryList().geomMemory /
              (1024 * 1024)
            ).toFixed(2)} Mb`;
            this.$store.commit('setIsGeometryLoaded', true);

            let bounding = this.viewer.model.getBoundingBox();

            let unitScale = this.$store.state.unitScale ?? 1

            let isLargeModel = Math.abs(bounding.max.x) * unitScale > 1500 / unitScale || Math.abs(bounding.max.y) * unitScale > 1500 / unitScale

            this.$store.commit('setIsLargeModel', isLargeModel);

            if (isLargeModel) this.viewer.impl.setNearRadius(0);

            var geometryLoadedCallback =
              this.$store.getters.GET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK;

            if (geometryLoadedCallback) {
              geometryLoadedCallback();
              this.$store.commit('SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK', null);
            }

            if (this.forgeService.tagToZoomToIn3D) {
              setTimeout(() => {
                this.forgeService.zoomInAllAvailableViewers(
                  this.forgeService.tagToZoomToIn3D,
                  true,
                );
                this.forgeService.tagToZoomToIn3D = null;
              }, 0);
            }
          });

          this.viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, () => {
            this.$store.commit('setIsTreeLoaded', true);

            this.$store.dispatch('fillAllModelProperties', { viewer: this.viewer });

            this.levels.forEach(async level => {
              if (!level.elementsCount) {
                const elements = await this.forgeService.getLevelElements(level);
                level.elementsCount = elements.length;
                levelsService.editLevel(this.assetId, level);
              }
            });
          });
          this.viewer.addEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, (e) => {
            let callback = this.$store.getters.GET_ON_SELECTION_CHANGED_CALLBACK;

            if (!callback) return;

            let selection = this.viewer.model.selector.getSelection();

            if (selection.length == 0) return;

            let obj = this.forgeService.dbidToForgeObject(selection[0], this.viewer.model);

            if (!obj) return;

            let point = this.forgeService.view3dToWorld(
              getMiddleBBoxForGroup(selection, this.viewer.model).getCenter(),
            );

            callback(obj, point, selection);
          });

          this.forgeService.initializeMappingPointsEvents(this.viewer, true);

          this.resizeViewers();
        }, getStreamingApi(model.apsRegion));
      },
      launchViewer2D(level) {
        this.dispose2DViewer();
        this.shownLevel2D = level;
        this.forgeService.mappedPoint1 = { generalViewPoint: null, planViewPoint: null };
        this.forgeService.mappedPoint2 = { generalViewPoint: null, planViewPoint: null };
        this.isPoint1Valid = false;
        this.isPoint2Valid = false;
        this.$store.state.selectedLevel = level;
        this.launchViewer_Admin(level.planUrn, 'admin-forge-viewer2d', (viewer0) => {
          this.$store.state.planViewer = viewer0;
          this.forgeService.initializeMappingPointsEvents(this.$store.state.planViewer, false);
        }, getStreamingApi(level.apsRegion));
        this.resizeViewers();
      },
      async toggleLevelIn3D(level) {
        level.isShowingIn3D = !level.isShowingIn3D;
        if (this.viewer && this.viewer.getExtension('Mapping2d_3dExtension')) {
          this.forgeService.getMappingExtension3D().updateShownLevels();
        } else {
          let targetModel = await this.$store.dispatch('GET_MAIN_MODEL');
          if (targetModel) this.launchViewer3D(targetModel);
          else {
            this.$dialog.notify.error('Please upload 3d model first.', {
              position: 'top-right',
              timeout: 3000,
            });

            return;
          }
        }
        this.$store.state.selectedLevel = level;
      },
      resizeViewers() {
        setTimeout(() => {
          if (this.viewer) this.viewer.resize();
          if (this.$store.state.planViewer) this.$store.state.planViewer.resize();
        }, 100);
      },
      launchViewer_Admin(urn, containerId, callback, streamingApi = 'streamingV2_EU') {
        this.$store.state.currentUrn = urn;
        var options = {
          // env: 'AutodeskProduction',
          env: 'AutodeskProduction2',
          api: streamingApi,
          getAccessToken: getForgeToken,
        };
        let viewer0 = null;
        Autodesk.Viewing.Initializer(options, () => {
          let container = document.getElementById(containerId);
          viewer0 = new Autodesk.Viewing.GuiViewer3D(container, {
            extensions: ['Cropping3DExtension'],
          });
          viewer0.start();
          var documentId = 'urn:' + urn;
          Autodesk.Viewing.Document.load(
            documentId,
            (doc) => {
              var viewables = doc.getRoot().getDefaultGeometry();
              viewer0.loadDocumentNode(doc, viewables).then((i) => {
                viewer0.navigation.setReverseZoomDirection(true);
                callback(viewer0);
              });
            },
            this.onDocumentLoadFailure,
          );
        });
      },
      onDocumentLoadFailure(viewerErrorCode) {
        debugError('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
      },
      disposeViewer() {
        this.dispose3DViewer();
        this.dispose2DViewer();
        Autodesk.Viewing.shutdown();
      },
      dispose3DViewer() {
        dispose3DViewer();
        this.$store.commit('setIsGeometryLoaded', false);
        this.$store.commit('setIsTreeLoaded', false);
        this.shownModel = null;
        this.resizeViewers();
      },
      dispose2DViewer() {
        dispose2DViewer();
        this.shownLevel2D = null;
        this.resizeViewers();
      },
      minPointHandle() {
        this.$dialog.notify.info('Click on the min point on the plan viewer', {
          position: 'top-right',
          timeout: 3000,
        });

        const handler = new getPointOnViewerHandler(this.planViewer);

        handler.then((point) => {
            this.minPoint = point;

            this.$refs.pointFormDialog.onDone = (point) => {
              if (!point) {
                this.minPoint3d = null;
                this.minPoint = null;
                return;
              }

              this.minPoint3d = point;

              if (this.maxPoint3d)
                this.completeMapping();
            };

            this.$dialog.notify.info('Please add the min point info', {
              position: 'top-right',
              timeout: 3000,
            });

            this.$refs.pointFormDialog.open();
          })
          .catch(debugLog);
      },
      maxPointHandle() {
        this.$dialog.notify.info('Click on the max point on the plan viewer', {
          position: 'top-right',
          timeout: 3000,
        });

        const handler = new getPointOnViewerHandler(this.planViewer);

        handler.then((point) => {
            this.maxPoint = point;

            this.$refs.pointFormDialog.onDone = (point) => {
              if (!point) {
                this.maxPoint3d = null;
                this.maxPoint = null;
                return;
              }

              this.maxPoint3d = point;

              if (this.minPoint3d)
                this.completeMapping();
            };

            this.$dialog.notify.info('Please add the max point info', {
              position: 'top-right',
              timeout: 3000,
            });

            this.$refs.pointFormDialog.open();
          })
          .catch(debugLog);
      },
      completeMapping() {
        debugLog('minPoint3d', this.minPoint3d);
        debugLog('maxPoint3d', this.maxPoint3d);
        debugLog('minPoint', this.minPoint);
        debugLog('maxPoint', this.maxPoint);

        if (!this.minPoint3d || !this.maxPoint3d || !this.minPoint || !this.maxPoint) return;

        this.$store.state.selectedLevel.fillAlignment(this.minPoint, this.minPoint3d, this.maxPoint, this.maxPoint3d);

        levelsService.editLevel(this.assetId, this.$store.state.selectedLevel);
      },
      clickOnP1() {
        this.forgeService.mappedPoint1 = { generalViewPoint: null, planViewPoint: null };
        this.forgeService.isPickingMappingPoint1 = true;
        this.forgeService.isPickingMappingPoint2 = false;
        this.isPoint1Valid = false;
      },
      clickOnP2() {
        this.forgeService.mappedPoint2 = { generalViewPoint: null, planViewPoint: null };

        this.forgeService.isPickingMappingPoint2 = true;
        this.forgeService.isPickingMappingPoint1 = false;
        this.isPoint2Valid = false;
      },
      updateCategoryHandler(category) {
        this.$refs.UpdateCategoryPopup.open(category);
      },
      addNewCategory(category) {
        var nameExist = this.categories.some((c) => c.name == category.name);

        if (nameExist) {
          this.$dialog.notify.warning('Category Name Already Exist', {
            position: 'top-right',
            timeout: 3000,
          });

          return;
        }

        this.addNewCategoryAPI(category, (newCategory) => {
          this.$store.state.categories.push(newCategory);
        });
      },
      onUpdateCategory(category) {
        var nameExist = this.categories.some((c) => c.name == category.name && c.id != category.id);

        if (nameExist) {
          this.$dialog.notify.warning('Category Name Already Exist', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.updateCategoryAPI(category, (newCategory) => {
          var foundIndex = this.categories.findIndex((x) => x.id == newCategory.id);
          let temp = this.categories;
          temp[foundIndex] = newCategory;
          this.$store.state.categories = [...temp];
        });
      },
      onDeleteCategory(category) {
        this.deleteCategoryAPI(category.id, (response) => {
          var foundIndex = this.categories.findIndex((x) => x.id == category.id);
          let temp = this.categories;
          temp.splice(foundIndex, 1);
          this.$store.state.categories = [...temp];
        });
      },
      addNewCategoryAPI(category, callback) {
        HttpService.post({
          url: 'api/forge/categories/add',
          data: category,
        })
          .then((response) => {
            callback(response.data);
          })
          .catch((error) => {
            debugLog(error);
          });
      },
      updateCategoryAPI(category, callback) {
        HttpService.post({
          url: 'api/forge/categories/update',
          data: category,
        })
          .then((response) => {
            callback(response.data);
          })
          .catch((error) => {
            debugLog(error);
          });
      },
      deleteCategoryAPI(categoryId, callback) {
        HttpService.post({ url: `api/forge/categories/delete/${categoryId}` })
          .then((response) => {
            callback(response.data);
          })
          .catch((error) => {
            debugLog(error);
          });
      },
      updatePointClouds(pointclouds) {
        this.pointclouds = pointclouds;
      },
      onUpdateProjects(projects) {
        this.$store.state.projects = projects;
      },
      onUpdateLevels(levels) {
        this.$store.state.levels = levels;
      },
      isPointCloudsDeleted(isDeleted) {
        if (isDeleted == true) {
          this.init();
        }
      },
    },
    computed: {
      viewer: {
        get() {
          return this.$store.state.viewer;
        },
        set(value) {
          this.$store.state.viewer = value;
        },
      },
      planViewer() {
        return this.$store.state.planViewer;
      },
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
      facility: {
        get() {
          return this.$store.getters['FACILITY/GET_FACILITY'];
        },
        set(value) {
          this.$store.commit('FACILITY/SET_FACILITY', value);
        },
      },
      mappingInfo() {
        return this.shownLevel2D?.hasAllMappingInfo();
      },
      isParentOrigin: function () {
        return this.$store.getters['getParentSiteName']?.includes('origin');
      },
      assetId() {
        return this.$route.params.id;
      },
      projects() {
        return this.$store.state.projects;
      },
      levels() {
        return this.$store.state.levels;
      },
      isAdmin() {
        return this.$store.getters['ACCOUNT/IS_ADMIN'];
      },
      categories() {
        return this.$store.state.categories;
      },
      forgeSettings() {
        return this.$store.state.forgeSettings;
      },
      localSuccessMessage: function () {
        return this.$store.getters['getSuccessMessage'] ?? '';
      },
      isAMIS() {
        return this.$store.state.forgeSettings?.isAMIS;
      },
      isInspectionOn() {
        return this.$store.state.forgeSettings.isInspectionsOn;
      },
      amisToken() {
        return this.$store.getters['GET_AMIS_TOKEN'];
      },
      showPopulateAutomaticTagsPopup() {
        return this.$store.getters['GET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP'];
      },
      viewerState() {
        return this.$store.state.viewerState;
      },
      createdOn() {
        if (!this.shownModel?.createDate) return '';

        var date = new Date(this.shownModel.createDate);

        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();

        // Add leading zero if value is less than 10
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
        if (hour < 10) {
          hour = '0' + hour;
        }
        if (minute < 10) {
          minute = '0' + minute;
        }

        return `${year}-${month}-${day} ${hour}:${minute}`;
      },
    },
    watch: {
      isInspectionOn: {
        handler: function (newValue, oldValue) {
          if (newValue && !this.amisToken) {
            getAMISToken()
              .then((token) => {
                this.$store.commit('SET_AMIS_TOKEN', token);
              })
              .catch((error) => {
                this.$dialog.notify.error('Failed to get AMIS token', {
                  position: 'top-right',
                  timeout: 3000,
                });
              });
          }
        },
      },
      facility: {
        deep: true,
        immediate: true,
        handler(facility) {
          if (facility) {
            this.$store.commit('setAssetId', facility.id);
            this.$store.commit('setAssetName', facility.name);
            this.init();
          }
        },
      },
    },
  };
</script>

<style>
  #main-admin-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model-row {
    width: calc(100% - 10px);
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px;
    cursor: pointer;
  }

  .model-row:hover {
    background-color: lightgray;
  }

  .model-version-checkbox {
    font-size: 15px;
  }

  .btn-hover-orange {
    font-size: 15px;
    color: gray;
    padding: 6px;
  }

  .btn-hover-orange:hover {
    color: orange;
  }

  .main-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
  }

  .left-content {
    position: relative;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 50%;
    overflow-y: auto;
    height: 100%;
  }

  .info-section {
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .section-title {
    width: calc(100% - 10px);
    font-size: 18px;
    font-weight: 400;
  }

  .clickable-header {
    cursor: pointer;
    padding: 5px;
    display: flex;
  }

  .clickable-header:hover {
    background-color: #ececec;
  }

  .top-points-above-plan {
    display: flex;
    flex-direction: row;
    height: 30px;
    align-items: center;
    position: absolute;
    top: 0;
    right: 35px;
    z-index: 3;
    padding: 1px;
    margin-top: 2px;
  }

  .collabsable-section {
    border: 1px solid lightgray;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.07),
      0 1px 5px 0 rgba(0, 0, 0, 0.06);
    margin-top: 10px;
    margin-right: 10px;
    width: calc(100% - 15px);
  }

  .expanded-section {
    width: 100%;
    animation-name: admin-tab-animation;
    animation-duration: 0.5s;
    position: relative;
  }

  @keyframes admin-tab-animation {
    0% {
      width: 0;
    }

    100% {
      width: 100%;
    }
  }

  .expanded-section div:first-child {
    animation-name: admin-childs-animation;
    animation-duration: 1s;
  }

  @keyframes admin-childs-animation {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .expand-collapse-ico {
    font-size: 15px;
    text-align: right;
  }

  .row-input {
    display: flex;
    padding: 5px;
    align-items: center;
    justify-content: space-between;
  }

  .top-right-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 13px;
    cursor: pointer;
    font-weight: 500;
    padding: 3px;
    font-family: 'Popins', sans-serif;
  }

  .top-right-btn:hover {
    background-color: red;
    color: white !important;
  }

  .upload-section {
    height: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }

  .property-wrapper {
    max-width: 300px;
    display: flex;
    column-gap: 5px;
  }

  .property-title {
    font-weight: 700;
    font-size: 14px;
    white-space: nowrap;
  }

  .model-info-section .property-value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .model-info-section {
    height: fit-content;
    padding: 5px 0px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }

  .model-info {
    display: flex;
    flex-direction: column;
    row-gap: 7px;
  }

  .admin-viewer {
    height: calc(50% - 35px);
    flex-grow: 1;
    width: 100%;
  }

  .admin-btn.disabled {
    background: var(--v-primary-lighten3);
    pointer-events: none;
  }

  .progress-circle {
    position: absolute;
    right: 120px;
  }

  .adsk-viewing-viewer.dark-theme .loading-spinner path {
    stroke: var(--v-primary-base);
  }
</style>
